import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { SlideEditorProvider, SlideEditorTemplate } from '@/features/slide-editor';

export const Route = createFileRoute('/_authenticated/slide-editor/')({
  validateSearch: z.object({
    slideId: z.number().optional(),
  }),
  component: SlideEditorPage,
});

function SlideEditorPage() {
  const { slideId } = Route.useSearch();
  return (
    <SlideEditorProvider {...(slideId !== undefined ? { slideId } : {})}>
      <SlideEditorTemplate />
    </SlideEditorProvider>
  );
}
